// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-type-file__header {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.select-type-file__header strong {
  color: #00254A;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 265px;
}
.select-type-file__header img {
  margin-left: 104px;
  margin-bottom: 18px;
}

.select-type-file__container {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
}
.select-type-file__container .select-type-file__container--bootom {
  display: flex;
  padding: 8px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid var(--escala-de-grises-gris-500, #8D94A4);
  height: 96px;
}
.select-type-file__container .select-type-file__container--bootom:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/proof-address-condition/select-type-file/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAER;AAAI;EACI,kBAAA;EACA,mBAAA;AAER;;AAEA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AACJ;AAAI;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,2DAAA;EACA,YAAA;AAER;AADQ;EACI,eAAA;AAGZ","sourcesContent":[".select-type-file__header {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    strong {\n        color: #00254A;\n        font-family: Roboto;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        width:265px\n    }\n    img {\n        margin-left: 104px;\n        margin-bottom: 18px;\n    }\n}\n\n.select-type-file__container {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    margin-top: 22px;\n    .select-type-file__container--bootom {\n        display: flex;\n        padding: 8px 0px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        flex: 1 0 0;\n        border-radius: 8px;\n        border: 1px solid var(--escala-de-grises-gris-500, #8D94A4);\n        height:96px;\n        &:hover{\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
